var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UsersBisnisUnitList',{attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }